import { createBrowserHistory } from 'history'
import type { History } from 'history'

// export const BLOCKING = '\xff'

export const history = createBrowserHistory({
  // history.block is not needed as window.history.pushState/replaceState are overridden
  // getUserConfirmation(message, callback) {
  //   if (message === BLOCKING) {
  //     callback(false)
  //   }
  //   else if (message) {
  //     const allow = window.confirm(message)
  //     callback(allow)
  //   }
  //   else {
  //     callback(true)
  //   }
  // }
}) as History
if (sessionStorage.__DEBUG_ON_HISTORY) {
  const push = history.push.bind(history)
  history.push = (...args) => {
    console.warn('history.push', ...args)
    return push(...args)
  }
  const replace = history.replace.bind(history)
  history.replace = (...args) => {
    console.warn('history.replace', ...args)
    return replace(...args)
  }
}

// patch window.history.pushState and window.history.replaceState
const winHistory = window.history
const { pushState: pushStateOrg, replaceState: replaceStateOrg } = winHistory
const pushState = (state: any, unused: string, url?: string | URL | null) => {
  const event = new CustomEvent('statechange', { detail: { state, url, action: 'PUSH' } })
  const result = window.dispatchEvent(event)
  if (result !== false) {
    pushStateOrg.call(winHistory, state, unused, url)
  }
}
const replaceState = (state: any, unused: string, url?: string | URL | null) => {
  const event = new CustomEvent('statechange', { detail: { state, url, action: 'REPLACE' } })
  const result = window.dispatchEvent(event)
  if (result !== false) {
    replaceStateOrg.call(winHistory, state, unused, url)
  }
}
Object.defineProperties(window.history, {
  pushState: { value: pushState },
  replaceState: { value: replaceState }
})

export default history
